import Api from './Api';

/* Endpoints for the bid category reports, balances, deleted users and the bid-update audit.
   Api already handles the Invalid-Token redirect, so these just name the routes. */
class ReportsV2 {
    bidTypes() { return Api.get('report/bid-types'); }
    bids(obj) { return Api.post('report/bids', obj); }
    userBalances(obj) { return Api.post('report/user-balances', obj); }
    deletedUsers(obj) { return Api.post('report/deleted-users', obj); }
    bidUpdates(obj) { return Api.post('report/bid-updates', obj); }
    markets() { return Api.get('markets'); }
}
export default new ReportsV2();
